export enum EOfferSpendByOfferView {
	Day = 'day',
	Month = 'month',
}

export const OFFER_SPEND_BY_OFFER_VIEW_LABEL_MAP: Record<EOfferSpendByOfferView, string> = {
	[EOfferSpendByOfferView.Day]: `offer_spend_by_offer_view.${EOfferSpendByOfferView.Day}`,
	[EOfferSpendByOfferView.Month]: `offer_spend_by_offer_view.${EOfferSpendByOfferView.Month}`
}